import {FormatDateToCA, SecondsToTime} from '../../../../../app/features'
import {Link} from 'react-router-dom'
import {PATH_CONTACTS} from '../../../../../app/routing/paths'
import {CallTrackingDataTable, TransactionBg, useCalls} from '../../../../../app/@types'
import {AddToContacts} from '../../../modals/AddToContacts'
import React, {FC} from 'react'

type Props = {
    paginatedData: CallTrackingDataTable[]
}
const Row: FC<Props> = ({paginatedData}) => {

    const {triggerReload} = useCalls()

    return (
        <>
            {
                paginatedData.map((item, index) => (
                    <tr key={index}>
                        <td>{FormatDateToCA(item.called_at)}</td>
                        <td>
                            <Link to={`${PATH_CONTACTS.contactEdit}/${item.subscriber_id}`}
                                  className="text-gray-800 text-hover-primary fw-bolder">
                                {item.subscriber && item.subscriber}
                            </Link>
                        </td>
                        <td>{item.cleverphone}</td>
                        <td>{item.callFrom}</td>
                        <td>{item.transferTo}</td>
                        <td>
                            <span
                                className={`badge badge-light-${TransactionBg(item.transactiontype)} fs-8 fw-bolder text-capitalize`}>{item.transactiontype}</span>
                        </td>
                        <td>{SecondsToTime(item.duration)}</td>
                        <td>
                            {
                                !item.subscriber &&
                              <AddToContacts index={item.id}
                                             initialValues={{
                                                 first_name: '',
                                                 last_name: '',
                                                 companyName: '',
                                                 street: '',
                                                 email: '',
                                                 number: item.callFrom || '',
                                             }}
                                             triggerReload={triggerReload}
                                             textIcon={false}
                              />
                            }
                        </td>
                    </tr>
                ))
            }
        </>
    )
}

export {Row}